// Fisher-Yates. Liefert eine NEUE Array-Kopie; mutiert das Original nicht.
export function shuffleArray(arr, rng = Math.random) {
  const result = [...arr];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

// Liefert eine NEUE Frage mit gemischten Antwort-Optionen; mutiert das Original nicht.
export function shuffleQuestion(q, rng = Math.random) {
  if (!q || typeof q !== 'object') return q;
  switch (q.type) {
    case 'multipleChoice':
    case 'imageQuestion': {
      if (!q.options || typeof q.options !== 'object') return q;
      const entries = Object.entries(q.options); // [[origKey, value], ...]
      const displayKeys = entries.map(([k]) => k); // Original-Keyfolge (A, B, C, …)
      const shuffled = shuffleArray(entries, rng); // [[origKey, value], ...] gemischt
      const newOptions = {};
      let newCorrect = q.correct;
      shuffled.forEach(([origKey, value], i) => {
        const displayKey = displayKeys[i];
        newOptions[displayKey] = value;
        if (origKey === q.correct) newCorrect = displayKey;
      });
      return { ...q, options: newOptions, correct: newCorrect };
    }
    case 'dragdrop': {
      if (!Array.isArray(q.dropTargets)) return q;
      return { ...q, dropTargets: shuffleArray(q.dropTargets, rng) };
    }
    case 'multiDragdrop': {
      const targets = Array.isArray(q.targets) ? shuffleArray(q.targets, rng) : q.targets;
      const pieces = Array.isArray(q.pieces) ? shuffleArray(q.pieces, rng) : q.pieces;
      return { ...q, targets, pieces };
    }
    default:
      return q;
  }
}

// Deterministischer, gesäter PRNG. Liefert eine Funktion () => [0,1).
export function mulberry32(seed) {
  let a = seed >>> 0;
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// Mischt NUR die Optionen innerhalb jeder Frage; Fragereihenfolge = Eingangsreihenfolge.
// Options-Reihenfolge pro Frage ist stabil über Aufrufe (Seed pro q.id im cache).
export function stabilizeQuestions(list, cache, rng = Math.random) {
  if (!Array.isArray(list)) return [];
  if (!cache.seeds) cache.seeds = new Map();

  const presentIds = new Set();
  const result = list.map((q) => {
    const id = q.id;
    presentIds.add(id);
    if (!cache.seeds.has(id)) {
      cache.seeds.set(id, Math.floor(rng() * 0x7fffffff));
    }
    return shuffleQuestion(q, mulberry32(cache.seeds.get(id)));
  });

  for (const id of Array.from(cache.seeds.keys())) {
    if (!presentIds.has(id)) cache.seeds.delete(id);
  }
  return result;
}
